import './style';
import App from './components/app';
import "@fontsource/pt-sans";

export default App;
